import ErrorPage from "../pages/ErrorPage";
import MenuPage from "../pages/menu/MenuPage";
import ManualDownloadPage from "../pages/menu/download/ManualDownloadPage";
import PluginDownloadPage from "../pages/menu/download/PluginDownloadPage";
import PasswordChangeCompletePage from "../pages/menu/passwordChange/PassowrdChangeCompletePage";
import PasswordChangePage from "../pages/menu/passwordChange/PasswordChangePage";
import PlanUpgradeCompletePage from "../pages/menu/planUpgrade/PlanUpgradeCompletePage";
import PlanUpgradeStepperPage from "../pages/menu/planUpgrade/PlanUpgradeStepperPage";
import UserInfoUpdateCompletePage from "../pages/menu/userInfoUpdate/UserInfoUpdateCompletePage";
import UserInfoUpdatePage from "../pages/menu/userInfoUpdate/UserInfoUpdatePage";
import EmailChangeCompletePage from "../pages/menu/userInfoUpdate/emailChange/EmailChangeCompletePage";
import EmailChangeStepperPage from "../pages/menu/userInfoUpdate/emailChange/EmailChangeStepperPage";
import PhoneNumChangeCompletePage from "../pages/menu/userInfoUpdate/phoneNumChange/PhoneNumChangeCompletePage";
import PhoneNumChangeStepperPage from "../pages/menu/userInfoUpdate/phoneNumChange/PhoneNumChangeStepperPage";
import SignInPage from "../pages/signin/SignInPage";
import PasswordForgotPage from "../pages/signin/passwordReset/PasswordForgotPage";
import PasswordResetPage from "../pages/signin/passwordReset/PasswordResetPage";
import SignInCapthcaPage from "../pages/signin/signInCaptchaPage";
import SignUpCompletePage from "../pages/signup/SignUpCompletePage";
import SignUpStepperPage from "../pages/signup/SignUpStepperPage";
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

const AppRoutes = () => (
  <Router>
    <Routes>
      <Route path="/" element={<SignUpStepperPage />} />
      <Route path="/signin" element={<SignInPage />} />
      <Route path="/signin/auth" element={<SignInCapthcaPage />} />
      <Route path="/menu" element={<MenuPage />} />
      <Route path="/signup/comp" element={<SignUpCompletePage />} />
      <Route path="/upgrade" element={<PlanUpgradeStepperPage />} />
      <Route path="/upgrade/comp" element={<PlanUpgradeCompletePage />} />
      <Route path="/dl/plugin" element={<PluginDownloadPage />} />
      <Route path="/dl/manual" element={<ManualDownloadPage />} />
      <Route path="/pw/change" element={<PasswordChangePage />} />
      <Route path="/pw/change/comp" element={<PasswordChangeCompletePage />} />
      <Route path="/pw/forgot" element={<PasswordForgotPage />} />
      <Route path="/pw/reset" element={<PasswordResetPage />} />
      <Route path="/pw/reset/comp" element={<PasswordChangeCompletePage />} />
      <Route path="/update" element={<UserInfoUpdatePage />} />
      <Route path="/update/comp" element={<UserInfoUpdateCompletePage />} />
      <Route path="/pn/change" element={<PhoneNumChangeStepperPage />} />
      <Route path="/pn/change/comp" element={<PhoneNumChangeCompletePage />} />
      <Route path="/em/change" element={<EmailChangeStepperPage />} />
      <Route path="/em/change/comp" element={<EmailChangeCompletePage />} />
      <Route path="/error" element={<ErrorPage />} />
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  </Router>
);

export default AppRoutes;
